var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "800" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-5 pr-2 pt-4 pb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" TPR/EDLC Alignment Warning ")
              ]),
              _c(
                "v-card-subtitle",
                {
                  staticClass: "pa-0 my-2",
                  staticStyle: { "word-break": "break-word" }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.billing_mode +
                          " promotions were detected that overlap this promotion but do not share the same start and/or end dates."
                      )
                  ),
                  _c("br"),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        "Please ensure that " +
                          _vm.billing_mode +
                          " promotions intended to stack have matching start and end dates."
                      )
                    )
                  ]),
                  _vm._v(" Continue? ")
                ]
              )
            ],
            1
          ),
          _c("v-divider", { staticClass: "mx-4" }),
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.misalignedPromos,
                  dense: "",
                  height: _vm.tableHeight,
                  "fixed-header": "",
                  "disable-pagination": "",
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.promo_number",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "primary--text",
                              staticStyle: { "text-decoration": "none" },
                              attrs: {
                                to: { path: "/promo?id=" + item.promo_id },
                                target: "_blank"
                              }
                            },
                            [_vm._v(" " + _vm._s(item.promo_number) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.start_dt",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.end_dt
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$config.formatDate(item.start_dt))
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.end_dt",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.end_dt
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$config.formatDate(item.end_dt))
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4",
                      attrs: { color: "warning" },
                      on: { click: _vm.submitMisalignedTPR }
                    },
                    [_vm._v(" Submit ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }